"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYBACK_RATES = void 0;
/** 배속 선택지 — 운영 요청 순서 그대로 */
exports.PLAYBACK_RATES = [
    { id: '0.5', title: '0.5배' },
    { id: '0.75', title: '0.75배' },
    { id: '1', title: '1.0배' },
    { id: '1.25', title: '1.25배' },
    { id: '1.5', title: '1.5배' },
    { id: '1.75', title: '1.75배' },
    { id: '2', title: '2.0배' },
];
